(function () {
  function loadScript(src, callback) {
    const s = document.createElement('script');
    s.src = src;
    s.onload = callback;
    document.head.appendChild(s);
  }

  function initPanzoom() {
    loadScript(
      'https://cdn.jsdelivr.net/npm/@panzoom/panzoom@4.5.1/dist/panzoom.min.js',
      function () {
        // Watch for Dawn's product media modal opening
        const observer = new MutationObserver(function () {
          const modal = document.querySelector('.product-media-modal[open], .product-media-modal__dialog[open]');
          if (!modal || modal.dataset.pzAttached) return;
          modal.dataset.pzAttached = 'true';

          const img = modal.querySelector('img');
          if (!img) return;

          img.style.cursor = 'grab';
          img.style.maxWidth = 'none';
          img.style.width = '100%';

          const pz = Panzoom(img, {
            maxScale: 5,
            contain: 'outside',
            cursor: 'grab',
          });

          img.parentElement.addEventListener('wheel', pz.zoomWithWheel);

          // Reset when modal closes
          const closeBtn = modal.querySelector('.product-media-modal__toggle, [aria-label="Close"]');
          if (closeBtn) {
            closeBtn.addEventListener('click', function () {
              pz.destroy();
              modal.dataset.pzAttached = '';
            });
          }
        });

        observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPanzoom);
  } else {
    initPanzoom();
  }
})();